var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7386 5.79089L8.79026 10.781C8.74488 10.8384 8.71541 10.9067 8.70482 10.9791C8.69422 11.0515 8.70287 11.1254 8.72989 11.1933L11.0203 16.943C11.2253 17.4769 11.9798 17.4792 12.1865 16.9454L18.264 1.31484C18.306 1.20672 18.317 1.08906 18.2958 0.975032C18.2747 0.861005 18.2223 0.755105 18.1444 0.669178C18.0665 0.583251 17.9663 0.520687 17.8549 0.488484C17.7434 0.456282 17.6253 0.455711 17.5136 0.486835L1.36263 5.00318C0.811702 5.15724 0.740002 5.90828 1.25074 6.16404L6.74884 9.00637C6.81385 9.03993 6.88655 9.05578 6.95962 9.05233C7.0327 9.04887 7.10358 9.02624 7.16514 8.9867L12.5182 5.54643C12.5514 5.52477 12.5912 5.51565 12.6305 5.52072C12.6699 5.52579 12.7061 5.54471 12.7327 5.57409C12.7593 5.60347 12.7746 5.64138 12.7758 5.68101C12.777 5.72064 12.764 5.7594 12.7392 5.79033L12.7386 5.79089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmpIcon);
export default __webpack_public_path__ + "static/media/smp-icon.e7f7043035a31d07351e2e78698de4ad.svg";
export { ForwardRef as ReactComponent };